import ApiService from "@/common/api.service";

const TO_PATH = "stock/transport-orders";
const SHIPMENT_PATH = "stock/shipments";

export const GET_STOCK_SHIPMENTS = "getStockShipments";
export const GET_STOCK_SHIPMENT_GROUPS = "getStockShipmentGroups";
export const CREATE_STOCK_SHIPMENT = "createStockShipment";
export const UPDATE_STOCK_SHIPMENT = "updateStockShipment";
export const DELETE_STOCK_SHIPMENT = "deleteStockShipment";
export const SAVE_STOCK_SHIPMENT_CMR = "saveStockShipmentCmr";
export const SAVE_STOCK_SHIPMENT_TRADE_DOCUMENT = "saveStockShipmentTradeDocument";
export const GENERATE_STOCK_SHIPMENT_CMR = "generateStockShipmentCmr";
export const GENERATE_STOCK_SHIPMENT_TRADE_DOCUMENT = "generateStockShipmentTradeDocument";
export const DOWNLOAD_STOCK_SHIPMENT_FILE = "downloadStockShipmentFile";

const actions = {
  [GET_STOCK_SHIPMENTS](context, transportOrderId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${TO_PATH}/${transportOrderId}/shipments`)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [GET_STOCK_SHIPMENT_GROUPS](context, transportOrderId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${TO_PATH}/${transportOrderId}/shipment-groups`)
        .then(({ data }) => resolve(data.data || data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [CREATE_STOCK_SHIPMENT](context, { transportOrderId, params }) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${TO_PATH}/${transportOrderId}/shipments`, params || {})
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [UPDATE_STOCK_SHIPMENT](context, { id, params }) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${SHIPMENT_PATH}/${id}`, params || {})
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [DELETE_STOCK_SHIPMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${SHIPMENT_PATH}/${id}`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [SAVE_STOCK_SHIPMENT_CMR](context, { id, params }) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${SHIPMENT_PATH}/${id}/cmr`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [SAVE_STOCK_SHIPMENT_TRADE_DOCUMENT](context, { id, params }) {
    return new Promise((resolve, reject) => {
      ApiService.put(`${SHIPMENT_PATH}/${id}/trade-document`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [GENERATE_STOCK_SHIPMENT_CMR](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${SHIPMENT_PATH}/${id}/cmr/generate`)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [GENERATE_STOCK_SHIPMENT_TRADE_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${SHIPMENT_PATH}/${id}/trade-document/generate`)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },
  [DOWNLOAD_STOCK_SHIPMENT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${SHIPMENT_PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },
};

export default { actions };
